export const FAVOURITES_SUMMARY_FETCHED_EVENT = 'FAVOURITES_SUMMARY_FETCHED';
export const FAVOURITE_ADDED_EVENT = 'FAVOURITE_ADDED';
export const FAVOURITE_REMOVED_EVENT = 'FAVOURITE_REMOVED';
